import { Component } from '@angular/core';

@Component({
	selector: 'app-components-empty',
  templateUrl: './empty.component.html'
})
export class EmptyComponent {
}
